import { render } from "./DashboardView.vue?vue&type=template&id=624578b4&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import "@/assets/css/DashboardView.css?vue&type=style&index=0&id=624578b4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624578b4"]])

export default __exports__